export default [
  {
    checkout: "Checkout",
    copyright:
      "©2019 - " +
      new Date().getFullYear() +
      " Copyright Alle rettigheder forbeholdes Orderapp®",
    dashboard: "Dashboard",
    discovery: "Opdagelse",
    menu: "Opdagelse",
    home: "Hjem",
    orders: "Ordre",
    profile: "Profil",
    stores: "Butikker",
    thanks: "Tak",
    ThanksQuick: "Tak",
    qrcodes: "QR Codes",
    customers: "Kunder",
    Customers: "Kunder",
    "customer-detail": "Customer details",
  },
];
